export function PhoneFrame({ src, alt, className = "", glow = false, size = "md" }) {
  const widths = { sm: "max-w-[230px]", md: "max-w-[300px]", lg: "max-w-[340px]" };
  return (
    <div className={`relative ${className}`}>
      {glow && (
        <div className="pointer-events-none absolute -inset-8 rounded-[3.5rem] bg-brand-orange/25 blur-[90px]" />
      )}
      <div
        className={`relative mx-auto w-full ${widths[size]} overflow-hidden rounded-[2.6rem] border-[7px] border-neutral-800 bg-neutral-900 shadow-[0_40px_90px_-30px_rgba(0,0,0,0.9)] ring-1 ring-white/10`}
      >
        <img src={src} alt={alt} loading="lazy" className="block w-full" />
      </div>
    </div>
  );
}
